import React from 'react';
import { TextInput, TextArea, StringList, CardList, SectionHeader } from './Fields';

const ModulosEditor = ({ data, onChange }) => {
  const set = (key, val) => onChange({ ...data, [key]: val });

  return (
    <div>
      <SectionHeader title="Seção Módulos" />
      <TextInput label="Título" value={data.heading} onChange={v => set('heading', v)} />
      <TextArea label="Subtítulo" value={data.subheading} onChange={v => set('subheading', v)} />

      <CardList
        label="Módulos"
        value={data.modules}
        onChange={v => set('modules', v)}
        emptyCard={{ icon: 'dashboard', iconColor: 'text-blue-600', bgColor: 'bg-blue-50', title: '', features: [] }}
        renderCard={(item, i, update) => (
          <div className="space-y-2">
            <TextInput label="Título do módulo" value={item.title} onChange={v => update({ title: v })} />
            <div className="grid grid-cols-2 gap-2">
              <TextInput label="Ícone (Material Icons)" value={item.icon} onChange={v => update({ icon: v })} hint="Ex: dashboard, assignment" />
              <TextInput label="Cor do ícone" value={item.iconColor} onChange={v => update({ iconColor: v })} hint="Ex: text-blue-600" />
            </div>
            <StringList label="Features" value={item.features} onChange={v => update({ features: v })} placeholder="Feature..." />
          </div>
        )}
      />

      <CardList
        label="Diferenciais"
        value={data.differentials}
        onChange={v => set('differentials', v)}
        emptyCard={{ icon: 'star', iconColor: 'text-blue-600', bgColor: 'bg-blue-50', title: '', description: '' }}
        renderCard={(item, i, update) => (
          <div className="space-y-2">
            <TextInput label="Título" value={item.title} onChange={v => update({ title: v })} />
            <TextArea label="Descrição" value={item.description} onChange={v => update({ description: v })} rows={2} />
            <div className="grid grid-cols-2 gap-2">
              <TextInput label="Ícone" value={item.icon} onChange={v => update({ icon: v })} />
              <TextInput label="Cor do ícone" value={item.iconColor} onChange={v => update({ iconColor: v })} />
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default ModulosEditor;
